import { SidebarLayoutNew } from '../components/sidebar-layout-new'
import { BreadcrumbsNew } from '../components/breadcrumbs'
import { Fragment } from 'react/jsx-runtime'
const pages = [
  { name: "Settings", href: "/settings", current: true },
];
export default function Settings() {
  return (
    <Fragment>
      <SidebarLayoutNew selected_menu="settings">
        <BreadcrumbsNew pages={pages} />
       </SidebarLayoutNew>
    </Fragment>
  );
}